/* eslint-disable no-undef */
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { createAttachment, editAttachment, deleteDigitalContent } 
  from 'actions/digitalContentActions';
import LocaleContext from 'constants/localization';

import Form from 'react-bootstrap/Form';
import CreateResourceButton from './CreateResourceButton';
import EditLinkedResources from './EditLinkedResources';
import Header from 'field/common/Header';

// SPEC-37
const AttachmentEdit = ({ field, createAttachment, 
  editAttachment, deleteDigitalContent }) => {
  const LS = useContext(LocaleContext);

  const onRemove = (index, value) => {
    let reason = prompt(LS.prompt.removalReason, '')
    if (reason == '') {
      reason = null;
    }
    if (confirm(LS.prompt.removeAttachment)) {
      deleteDigitalContent(value.uri, field.predicate, index, reason);
    }
  };

  return (
    <Form.Group className="field" >
      <Header field={field} />
      <CreateResourceButton onCreate={createAttachment} label={field.label} />
      <EditLinkedResources 
        onEdit={editAttachment} 
        onRemove={onRemove} 
        values={field.values} />
    </Form.Group>
  );
};

AttachmentEdit.propTypes = {
  field: PropTypes.object.isRequired,
  createAttachment: PropTypes.func.isRequired,
  editAttachment: PropTypes.func.isRequired,
  deleteDigitalContent: PropTypes.func.isRequired,
};

export default connect(null, { createAttachment, 
  editAttachment, deleteDigitalContent })(AttachmentEdit);